import React from "react";
import { Icon } from "../../components/icon";
import { SocialMediaShare } from "./social_media_share";
import { useI18n } from "../../lib/i18n/i18n_provider";
import pluralize from "pluralize";
import { Spacer } from "../../offering/spacer";

interface OfferingIntroProps {
  title: string | React.ReactNode;
  htmlDescription?: string;
  address?: string;
  capacity?: number;
}

export function OfferingIntro(props: OfferingIntroProps) {
  const { fbt } = useI18n();
  const { title, htmlDescription, address, capacity } = props;

  return (
    <div data-testid="intro" className="offering-intro">
      <div
        className={`d-flex align-items-start justify-content-between ${
          capacity ? "mb-2" : "mb-4"
        }`}
      >
        <div className="offering-intro__title">
          {typeof title === "string" ? (
            <h1 className="m-0 me-3">{title}</h1>
          ) : (
            title
          )}
          {address && (
            <p className="mt-2">
              <Icon name="location" /> {address}
            </p>
          )}
        </div>
        <Spacer size={8} direction="horizontal" />
        <SocialMediaShare />
      </div>
      {capacity && (
        <div className="d-flex align-items-center gap-2 mb-4">
          <Icon className="capacity-icon" name="capacity" />
          <span>
            {fbt(
              `Up to ${fbt.param("capacity", capacity)} ${pluralize(
                "person",
                capacity
              )}`
            )}
          </span>
        </div>
      )}
      {htmlDescription && (
        <div
          className="offering-intro__description"
          dangerouslySetInnerHTML={{
            __html: htmlDescription,
          }}
        />
      )}
    </div>
  );
}
